import { FC } from 'react';

interface TabProps {
  label: string;
  isActive: boolean;
  count?: number;
  onClick: () => void;
  showCount?: boolean;
  isLoadingSuccess?: boolean;
  isLoadingData?: boolean;
}

const PayoutTab: FC<TabProps> = ({
  label,
  isActive,
  count,
  onClick,
  showCount = true,
  isLoadingSuccess = true,
  isLoadingData = false
}) => {
  return (
    <div
      onClick={onClick}
      className={`w-1/2 shrink-0 cursor-pointer py-2.5 text-center text-sbase font-semibold
        ${isActive ? 'rounded-md bg-primary text-secondary shadow-sm' : 'text-primaryText'}`}>
      {label}
      {isActive && showCount && isLoadingSuccess && !isLoadingData && (
        <span className="ml-1.5 rounded-[10px] bg-secondary px-2.5 py-0.5 text-px13 text-primary">{count}</span>
      )}
    </div>
  );
};

export default PayoutTab;
